import { IAppState } from '../../common/state';

export const selectNewbuildingLayoutDetailsModalOpen = (state: IAppState): boolean => {
  return state.newbuildingLayoutDetailsModal.open;
};
